import { isClient } from '@gateio/core-utils'

if (isClient()) {
  class WebComponentReact extends HTMLElement {
    // 属性监听器
    static get observedAttributes() {
      return ['data']
    }

    // 初始化
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
    }

    // 当属性改变时触发
    attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
      if (name === 'data' && newValue) {
        this.render(JSON.parse(newValue))
      }
    }

    // 渲染方法
    render(data: any) {
      this.shadowRoot!.innerHTML = `
        <style>
          img {
            max-width:100%;
            object-fit: cover;
          }
        </style>
        <div>
          ${data.value}
        </div>
      `
    }
  }

  customElements.define('web-component-react', WebComponentReact)
}
